const BUNNY_PLAYBACK_SEGMENT = "/play/";

export const isVideoMedia = (media = {}) =>
  (media?.mediaType || "").toUpperCase() === "VIDEO";

export const isImageMedia = (media = {}) =>
  (media?.mediaType || "").toUpperCase() === "IMAGE";

export const isBunnyStreamMedia = (media = {}) => {
  const storageProvider = (media?.storageProvider || "").toUpperCase();
  const resolvedUrl = getResolvedVideoUrl(media) || "";
  return (
    storageProvider === "BUNNY_STREAM" ||
    resolvedUrl.includes("video.bunnycdn.com") ||
    resolvedUrl.includes(BUNNY_PLAYBACK_SEGMENT) ||
    resolvedUrl.includes("iframe.mediadelivery.net")
  );
};

export const getResolvedImageUrl = (media = {}, fallback = "") =>
  media?.fileUrl || media?.thumbnailUrl || media?.mediaUrl || media?.url || fallback;

export const getResolvedPosterUrl = (media = {}, fallback = "") =>
  media?.thumbnailUrl || media?.fileUrl || media?.mediaUrl || media?.url || fallback;

export const getResolvedVideoUrl = (media = {}) =>
  media?.playbackUrl || media?.fileUrl || media?.mediaUrl || media?.url || "";

export const getBunnyEmbedUrl = (playbackUrl = "") => {
  try {
    const url = new URL(playbackUrl);
    const [, playSegment, libraryId, videoGuid] = url.pathname.split("/");
    if (playSegment !== "play" || !libraryId || !videoGuid) {
      return playbackUrl;
    }
    return `https://iframe.mediadelivery.net/embed/${libraryId}/${videoGuid}`;
  } catch (error) {
    return playbackUrl;
  }
};
